import React, { Component } from "react";
import moment from "moment-hijri";
import { connect } from "react-redux";

class ClientCalcStatuse extends Component {
    
    state = {
        loading: false,
        hideAceeptBtn: false,
        loadingCancelRate: false,
        StatusLogs: null,
    };
    componentDidMount() {
        const { StatusLogs } = this.props;
        //console.log(StatusLogs, "StatusLogs") 
        const filteredArr = StatusLogs?.filter(
            (v, i, a) =>
                a.findIndex(
                    (t) =>
                        t.FinancingRequestGeneralStatusId ===
                        v.FinancingRequestGeneralStatusId
                ) === i
        );
        //console.log(filteredArr);
        filteredArr?.some((ele) => ele.FinancingRequestGeneralStatusId === 7) &&
            this.setState({ hideAceeptBtn: true });
        this.setState({ StatusLogs: filteredArr || [] });
    }

    render() {
        const { StatusLogs } =
            this.state;
        return (
            <>

                <section className="statues-section">
                    <h4>الحسبة الاولية </h4>
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 24) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 25) {
                            return (
                                <div className="calc-timeline is-user-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 38) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 23) {
                            return (
                                <div className="calc-timeline is-user-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </section>

                <section className="statues-section">
                    <h4>المستندات </h4>
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 4) {
                            return (
                                <div className="calc-timeline is-user-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 8) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </section>

                {/* <section className="statues-section">
                    <h4>إرسال الطلب للعمليات  </h4>
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 34) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}

                </section> */}

                <section className="statues-section">
                    <h4>إرسال الطلب لجهة التمويل </h4>
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 37) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 5) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 9) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 10) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 42) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 7) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">تمت الموافقة على الحسبة</p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </section>

                <section className="statues-section">
                    <h4>التقييم </h4>
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 12) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 26) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 13) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 14) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 15) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                </section>

                <section className="statues-section">
                    <h4>الموافقات  </h4>
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 39) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 40) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 29) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 30) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 41) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 17) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 18) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </section>

                <section className="statues-section">
                    <h4>إتمام الصفقة</h4>
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 27) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 20) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 19) {
                            return (
                                <div className="calc-timeline is-agency-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 28) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 21) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 31) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 32) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })}
                    {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 33) {
                            return (
                                <div className="calc-timeline is-osool-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 43) {
                            return (
                                <div className="calc-timeline is-finance-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                    {/* {StatusLogs?.map((Statuse) => {
                        if (Statuse?.FinancingRequestGeneralStatusId === 44) {
                            return (
                                <div className="calc-timeline is-finance-statues">
                                    <div className="timeline-row-holder">
                                        <p className="timeline--p">
                                            {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                                        </p>
                                        <time className="timeline--time">
                                            {moment
                                                .utc(Statuse?.CreationDate)
                                                .local()
                                                .format("iYYYY/iM/iD - HH:MM")}
                                        </time>
                                    </div>
                                </div>
                            );
                        }
                    })} */}
                </section>

            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userRequest: state.user.userRequest,
});
export default connect(mapStateToProps)(ClientCalcStatuse);